import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgQuickpick = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        d="M4.25 13a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0M9.75 13a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0M7 15.75a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0M4.25 18.5a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0M9.75 18.5a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0M12.25 6a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0M16.75 6a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0M16.75 10.5a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M8.75 3c0-.966.784-1.75 1.75-1.75H21c.966 0 1.75.784 1.75 1.75v10.5A1.75 1.75 0 0 1 21 15.25h-5.75V21a1.75 1.75 0 0 1-1.75 1.75H3A1.75 1.75 0 0 1 1.25 21V10.5c0-.966.784-1.75 1.75-1.75h5.75zM3 10.25a.25.25 0 0 0-.25.25V21c0 .138.112.25.25.25h10.5a.25.25 0 0 0 .25-.25V10.5a.25.25 0 0 0-.25-.25zm12.25 3.5V10.5a1.75 1.75 0 0 0-1.75-1.75h-3.25V3a.25.25 0 0 1 .25-.25H21a.25.25 0 0 1 .25.25v10.5a.25.25 0 0 1-.25.25z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgQuickpick;
